/**
 * Console twin of the product's `#/shared/lib/ws` surface.
 *
 * The console has no tenant websocket yet, so subscriptions simply never
 * fire — the vendored components keep their query-driven data and miss only
 * the push-refresh. Constants and envelope types are the product's own files.
 */
import type { WsEnvelope } from './types'
import type { WsMessageType } from './constants'

export { WS_MESSAGE_TYPE, WS_STATUS } from './constants'
export type { WsMessageType, WsStatus } from './constants'
export type { WsEnvelope } from './types'

export function useWsSubscription<T = unknown>(
  _type: WsMessageType | WsMessageType[],
  _handler: (envelope: WsEnvelope<T>) => void,
): void {
  // No socket in the console — subscriptions are inert.
}

export function useWsSubscriptions<T = unknown>(
  _types: readonly string[],
  _listener: (envelope: WsEnvelope<T>) => void,
): void {
  // No socket in the console — subscriptions are inert.
}

export function useWsReconnect(_handler: () => void): void {
  // No socket in the console — reconnects never happen.
}

/** No socket in the console — sends vanish, opens never fire. */
export function sendWsMessage(_message: Record<string, unknown>): void {}

export function subscribeWsOpen(_handler: () => void): () => void {
  return () => {}
}
